/**
 * ThreatTraceabilityPage — embed-only 2.0 page wrapper.
 *
 * Mounted as the `traceability-v2` tab body inside ProjectWorkspace.
 * Thin wrapper that feeds `height: 100%` down so the inner DataTable
 * shell (Step 4+) can absorb the remaining vertical space.
 *
 * Step 3 ships an empty body shell; Step 4 drops in the
 * <ThreatTraceabilityTable> + the row adapter.
 */
import React from 'react';
import ThreatTraceabilityTable from './ThreatTraceabilityTable';
import styles from './ThreatTraceabilityPage.module.css';

const ThreatTraceabilityPage = ({ threadId, projectLoading = false }) => (
  <div className={styles.pageBody}>
    <ThreatTraceabilityTable threadId={threadId} projectLoading={projectLoading} />
  </div>
);

export default ThreatTraceabilityPage;
